import { Table, TableProps } from '@insight-health-ai/roseate/components';
import {
  AppointmentSlot,
  Clinic,
  useGetAppointmentSlotList,
} from 'src/hooks/frontdesk';
import { Tag } from 'antd';

export const AppointmentSlotTableView = () => {
  const { data, isLoading, isError } = useGetAppointmentSlotList();

  const slots = data?.appointmentSlotList || [];

  if (isError) {
    return (
      <div className="flex justify-center items-center p-8">
        <div className="text-red-500 text-lg">
          Error loading appointment slots
        </div>
      </div>
    );
  }

  const columns: TableProps<AppointmentSlot>['columns'] = [
    {
      title: 'Date & Time',
      key: 'datetime',
      width: 220,
      render: (_: any, record: AppointmentSlot) => (
        <div>
          <div>{record.date}</div>
          <div className="text-gray-500 text-sm">
            {record.start_time} - {record.end_time}
          </div>
        </div>
      ),
    },
    {
      title: 'Appointment Type',
      dataIndex: 'appointment_type',
      key: 'appointment_type',
      width: 150,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      render: (status: string) => {
        let color = 'default';
        if (status === 'Available') {
          color = 'green';
        } else if (status === 'Booked') {
          color = 'blue';
        } else if (status === 'Blocked') {
          color = 'red';
        }
        return <Tag color={color}>{status}</Tag>;
      },
    },
    {
      title: 'Clinic',
      dataIndex: 'clinic',
      key: 'clinic',
      width: 100,
      render: (clinic: Clinic) => <div>{clinic?.name}</div>,
    },
  ];

  return (
    <Table
      columns={columns}
      data={slots}
      loading={isLoading}
      pagination={{
        pageSize: 10,
        showSizeChanger: true,
        showTotal: (total: number, range: [number, number]) =>
          `${range[0]}-${range[1]} of ${total} appointment slots`,
      }}
      emptyText="No appointment slots found"
    />
  );
};
